import React from 'react';

import { useLoadApp } from '../hooks/store';
import Component from '../components/Bootstrap';

const Bootstrap = () => {

    const { loadApp } = useLoadApp();

    return <Component loadApp={loadApp} />;

};

export default Bootstrap;
